module.exports = __webpack_public_path__ + "img/undraw_personal_settings_blue.5d4697d8.svg";